import React, { useEffect } from 'react';
import { Badge, DropdownMenu, DropdownMenuItem, DVIcon } from '@develos/next-components';
import { MetricLocalization } from './types';
import { setCurrentMetricLocalization } from '@/store/metricLocalization/metricLocalizationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { storeSelectors } from '@/store';
import { useMetricLocalizations } from '@/hooks';

const LocalizationHeaderDropdown = () => {
  const dispatch = useDispatch();
  const { metricLocalizations } = useMetricLocalizations();
  const metricLocalization = useSelector(storeSelectors.selectCurrentMetricLocalization);
  const handleOnLocalizationClick = (point: MetricLocalization) => {
    dispatch(setCurrentMetricLocalization(point));
  };

  useEffect(() => {
    if (metricLocalizations && metricLocalizations.length > 0 && metricLocalization === null) {
      dispatch(setCurrentMetricLocalization(metricLocalizations[0]));
    }
  }, [metricLocalizations]);

  return (
    <div className="rm-flex rm-items-center">
      {metricLocalization && (
        <DropdownMenu
          trigger={
            <div className="rm-flex rm-items-center rm-gap-2 rm-text-xs rm-text-gray-600">
              <DVIcon name="MapPin" className="w-4 h-4" />
              {metricLocalization.name}
              <DVIcon name="ChevronDown" className="w-4 h-4" />
            </div>
          }
          dataTestId="localization-header-dropdown"
        >
          {metricLocalizations?.map((point: MetricLocalization) => (
            <DropdownMenuItem key={point.uId} onClick={() => handleOnLocalizationClick(point)}>
              <div className="rm-flex rm-items-center rm-gap-2">
                {point.name}
                {metricLocalization.uId === point.uId && <Badge variant="blue">Aktywny</Badge>}
              </div>
            </DropdownMenuItem>
          ))}
        </DropdownMenu>
      )}
    </div>
  );
};

export default LocalizationHeaderDropdown;
